import { createSelector } from 'reselect';
import { getGameStaticData } from '@gameday/utils/selectors/getGameStaticData';
import getQueryParamOverride from '@gameday/utils/getQueryParamOverride';

const useContentEpgOverride = getQueryParamOverride('useContentEpg');

const getDeviceInteraction = (state) => state.config?.deviceInteraction;
const getNativeVideoPlayer = (state) => state?.config?.nativeVideoPlayer;
const getLocalTimezone = (state) => state.config?.localTimezone;
const getAllHighlights = (state) => state?.allHighlights;
const getGameContext = (state) => state.config?.context?.gameContext;
const getMediaLinks = (state) => (useContentEpgOverride ?? state.config?.useContentEpg)
    ? state.schedule?.contentMediaLinks
    : state.schedule?.mediaLinks;
const getBlockLoginActivities = (state) => state?.config?.blockLoginActivities;

export const getHighlights = createSelector(
    [
        getDeviceInteraction,
        getNativeVideoPlayer,
        getLocalTimezone,
        getGameStaticData,
        getAllHighlights,
        getGameContext,
        getMediaLinks,
        getBlockLoginActivities
    ],
    (
        deviceInteraction,
        nativeVideoPlayer,
        localTimezone,
        gameStaticData,
        allHighlights,
        gameContext,
        mediaLinks,
        blockLoginActivities
    ) => {
        const { condensedGame, gameRecap } = allHighlights || {};
        const highlightVideoData = { condensedGame, gameRecap };
        const { tv } = mediaLinks || {};
        const {
            pk,
            datetime: {
                dateTime
            }
        } = gameStaticData;
        return ({
            deviceInteraction,
            nativeVideoPlayer,
            mlbTVInfo: {
                tvInfo: tv?.list,
                game_pk: pk,
                date: dateTime,
                tz: localTimezone,
                gameContext
            },
            highlightVideoData,
            blockLoginActivities
        });
    }
);
